import { render, staticRenderFns } from "./scoring.vue?vue&type=template&id=0dc2b077&scoped=true"
import script from "./scoring.vue?vue&type=script&lang=js"
export * from "./scoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc2b077",
  null
  
)

export default component.exports